<div class="container">
  <div class="section">
    <div class="section-info">
      <h3 class="title">
        {{ "advanced-pages.poi-th.title" | i18next
        }}<span class="tw-text-[#9FE9FE]">*</span>
      </h3>
      <span class="note">{{ "advanced-pages.poi-th.note" | i18next }}</span>
    </div>

    <div class="poi-options">
      <div class="poi-option" (click)="changeIdCategory('thai')">
        <div class="option-details">
          <h3 class="title">
            {{ "advanced-pages.poi-th.option-thai" | i18next }}
          </h3>
        </div>
        <img src="../../../../assets/icons/arrow-right.svg" alt="Arrow Right" />
      </div>
      <div class="separator">
        <div class="bar"></div>
        <div>
          <span>{{ "advanced-pages.poi-th.or" | i18next }}</span>
        </div>
        <div class="bar"></div>
      </div>
      <div class="poi-option" (click)="changeIdCategory('non-thai')">
        <div class="option-details">
          <h3 class="title">
            {{ "advanced-pages.poi-th.option-nonthai" | i18next }}
          </h3>
        </div>
        <img src="../../../../assets/icons/arrow-right.svg" alt="Arrow Right" />
      </div>
    </div>
  </div>

  <app-cta-buttons
    currentPage="poi"
    [pageNames]="advancedPages"
    tier="advanced"
    [nextButton]="false"
  ></app-cta-buttons>
</div>
